L.Control.WelcomeMessageControl = L.Control.extend({

    latest: "20210214",

    includes: (L.Evented.prototype || L.Mixin.Events),

    seen: function() {
        try {
           return typeof localStorage !== 'undefined' && localStorage.getItem('welcomeMessageSeen') == this.latest;
        } catch(err) {}
        return false;
    },

    show: function() {

        var overlay = L.DomUtil.create('div', 'welcome-message-overlay', document.body);

        var container = L.DomUtil.create('div', 'welcome-message welcome-message-visible', document.body);

        var header = L.DomUtil.create('h3', '', container);
        header.innerHTML = L.localisation.get('welcome.title');

        var text = L.DomUtil.create('div', '', container);
        var tapTerm = L.Browser.mobile ? 'touch and hold' : 'click';
        text.innerHTML = L.localisation.get('welcome.body');
        if (L.Browser.android) {
            text.innerHTML = text.innerHTML + '<p>'+L.localisation.get('welcome.appLinksAndroid')+'</p>';
        } else if (L.Browser.safari && L.Browser.mobile) {
            text.innerHTML = text.innerHTML + '<p>'+L.localisation.get('welcome.appLinksIOS')+'</p>';
        } else if (!is_app) {
            text.innerHTML = text.innerHTML + '<p>'+L.localisation.get('welcome.appLinks')+'</p>';
        }

        var link = L.DomUtil.create('a', 'btn', container);
        link.title = L.localisation.get('welcome.ok');
        link.innerHTML = L.localisation.get('welcome.ok');

        L.DomEvent.on(link, 'click', L.bind(function(e) {
            try {
               localStorage.setItem('welcomeMessageSeen', this.latest);
            } catch(err) {}
            container.style.display = 'none';
            overlay.style.display = 'none';
            L.DomEvent.preventDefault(e);
            this.fire('welcomemessageclosed');
        }, this));
    }
    
});

